import React, { useEffect } from 'react';
import { Paper,  Button, Typography, Container } from '@material-ui/core/';
import DeleteIcon from '@material-ui/icons/Delete';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import { getPost, deletePost } from '../../actions/posts';
import { getUsers } from '../../actions/auth'
import useStyles from './styles';
import {  useHistory } from 'react-router-dom'

const Post = ({ setCurrentId }) => {
  const { post } = useSelector((state) => state.posts);
  const user = useSelector((state) => state.auth.find ? state.auth.find((e) => e?._id === post?.creator) : null)
  const { id } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const loggedUser = JSON.parse(localStorage.getItem('profile'));

  useEffect(() => {
    
    dispatch(getPost(id));
    dispatch(getUsers());
    // eslint-disable-next-line
  }, [id]);

  if (!post && !user) return null;
  const Update = () => {
    setCurrentId(post._id)
    history.push('/form')
  }

  const Delete = () => {
    dispatch(deletePost(post._id))
    history.push('/')
  }

  return (
    <Container component="main" maxWidth="md">
      <Paper style={{ padding: '10px',marginTop:'80px' }} elevation={3}>
        <div className={classes.card}>
          <div className={classes.section1}>
          <img className={classes.media} src={post.pictureURL || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} alt={post.title} />
          </div>
          <div className={classes.section2}>
            <Typography gutterBottom variant="h4" component="h2">{post.title}</Typography>
            <Typography variant="h3" color="secondary" component="h2">{post.price} €</Typography>
            <Typography variant="body1" color="secondary" component="h2" className={classes.city}>{post.city}</Typography>
            <Typography variant="body2">Created {moment(post.createdAt).fromNow()}</Typography>
            <div className={classes.category}>
            <Typography variant="body2" color="textSecondary" component="h2">{post.category}</Typography>
            </div>
            {(loggedUser?.result?._id === post?.creator) && (
                    <div className={classes.buttons}>
                    <Button  color="primary" onClick={Update}> 
                    <EditIcon  /> 
                    Edit
                    </Button>
                    <Button  color="secondary" onClick={Delete}>
                      <DeleteIcon  /> Delete
                    </Button>
                    </div>
            )}
          </div>
          <div className={classes.section3}>
          <Typography variant="h6" component="p">Creator: {post.username}</Typography>
          <Typography variant="body2" component="p">Member since: {user ? moment(user.createdAt).format('Do MMM YYYY') : null}</Typography>
          <Typography variant="body2" component="p">Contact: {user?.phoneNum}</Typography>
          </div>
        </div>
        <div className={classes.section4}>
        <Typography variant="body2"  component="p" className={classes.description}>{post.description}</Typography>
        </div>
      </Paper>
    </Container> 
  );
};

export default Post;